import apiClient from '../apiClient';

const orientationService = {
  // Get all orientations with filtering
  getOrientations: async (params = {}) => {
    try {


      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.status) queryParams.append('status', params.status);
      if (params.type) queryParams.append('type', params.type);
      if (params.location) queryParams.append('location', params.location);
      if (params.department) queryParams.append('department', params.department);
      if (params.search) queryParams.append('search', params.search);
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);

      const url = `/orientation${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;


      const response = await apiClient.get(url);


      // Ensure consistent response format
      if (response.data && response.data.responseCode) {
        return response.data;
      } else {
        // Wrap direct response in standard format
        return {
          responseCode: 200,
          responseMessage: 'Orientations retrieved successfully',
          data: response.data
        };
      }
    } catch (error) {

      throw error;
    }
  },

  // Get unique locations
  getLocations: async () => {
    try {


      const response = await apiClient.get('/orientation/locations');


      if (response.data && response.data.responseCode) {
        return response.data;
      } else {
        return {
          responseCode: 200,
          responseMessage: 'Locations retrieved successfully',
          data: response.data
        };
      }
    } catch (error) {

      throw error;
    }
  },

  // Get orientation by ID
  getOrientationById: async (id) => {
    try {


      const response = await apiClient.get(`/orientation/${id}`);


      if (response.data && response.data.responseCode) {
        return response.data;
      } else {
        return {
          responseCode: 200,
          responseMessage: 'Orientation retrieved successfully',
          data: response.data
        };
      }
    } catch (error) {

      throw error;
    }
  },

  // Create new orientation
  createOrientation: async (orientationData) => {
    try {


      const response = await apiClient.post('/orientation', orientationData);


      if (response.data && response.data.responseCode) {
        return response.data;
      } else {
        return {
          responseCode: 201,
          responseMessage: 'Orientation created successfully',
          data: response.data
        };
      }
    } catch (error) {

      throw error;
    }
  },

  // Update orientation
  updateOrientation: async (id, orientationData) => {
    try {


      const response = await apiClient.put(`/orientation/${id}`, orientationData);


      if (response.data && response.data.responseCode) {
        return response.data;
      } else {
        return {
          responseCode: 200,
          responseMessage: 'Orientation updated successfully',
          data: response.data
        };
      }
    } catch (error) {

      throw error;
    }
  },

  // Delete orientation
  deleteOrientation: async (id) => {
    try {


      const response = await apiClient.delete(`/orientation/${id}`);


      if (response.data && response.data.responseCode) {
        return response.data;
      } else {
        return {
          responseCode: 200,
          responseMessage: 'Orientation deleted successfully',
          data: response.data
        };
      }
    } catch (error) {

      throw error;
    }
  },

  // Send orientation invites
  sendOrientationInvites: async (id, inviteData) => {
    try {


      const response = await apiClient.post(`/orientation/${id}/invites`, inviteData);


      if (response.data && response.data.responseCode) {
        return response.data;
      } else {
        return {
          responseCode: 200,
          responseMessage: 'Invites sent successfully',
          data: response.data
        };
      }
    } catch (error) {

      throw error;
    }
  },

  // Check for duplicate orientation
  checkDuplicateOrientation: async (orientationData) => {
    try {


      const response = await apiClient.post('/orientation/check-duplicate', orientationData);


      if (response.data && response.data.responseCode) {
        return response.data;
      } else {
        return {
          responseCode: 200,
          responseMessage: 'Duplicate check completed',
          data: response.data
        };
      }
    } catch (error) {

      throw error;
    }
  },

  // Clone orientation
  cloneOrientation: async (id, cloneData) => {
    try {


      const response = await apiClient.post(`/orientation/${id}/clone`, cloneData);


      if (response.data && response.data.responseCode) {
        return response.data;
      } else {
        return {
          responseCode: 201,
          responseMessage: 'Orientation cloned successfully',
          data: response.data
        };
      }
    } catch (error) {

      throw error;
    }
  },

  // Get orientation attendees
  getOrientationAttendees: async (id) => {
    try {


      const response = await apiClient.get(`/orientation/${id}/attendees`);


      if (response.data && response.data.responseCode) {
        return response.data;
      } else {
        return {
          responseCode: 200,
          responseMessage: 'Attendees retrieved successfully',
          data: response.data
        };
      }
    } catch (error) {

      throw error;
    }
  },

  // Export orientations (if backend supports it)
  exportOrientations: async (params = {}) => {
    try {


      const queryParams = new URLSearchParams();
      if (params.status) queryParams.append('status', params.status);
      if (params.type) queryParams.append('type', params.type);
      if (params.department) queryParams.append('department', params.department);
      if (params.location) queryParams.append('location', params.location);
      if (params.search) queryParams.append('search', params.search);
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);
      if (params.format) queryParams.append('format', params.format || 'csv');

      const url = `/orientation/export${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;


      const response = await apiClient.get(url, { responseType: 'blob' });


      return response;
    } catch (error) {

      throw error;
    }
  },

  // Update orientation statuses based on current time
  updateStatuses: async () => {
    try {


      const response = await apiClient.post('/orientation/status/update');


      if (response.data && response.data.responseCode) {
        return response.data;
      } else {
        return {
          responseCode: 200,
          responseMessage: 'Status updates completed successfully',
          data: response.data
        };
      }
    } catch (error) {

      throw error;
    }
  },

  // Get orientations that need status updates
  getStatusCandidates: async () => {
    try {


      const response = await apiClient.get('/orientation/status/candidates');


      if (response.data && response.data.responseCode) {
        return response.data;
      } else {
        return {
          responseCode: 200,
          responseMessage: 'Status candidates retrieved successfully',
          data: response.data
        };
      }
    } catch (error) {

      throw error;
    }
  },

  // Update specific orientation status
  updateOrientationStatus: async (id, status) => {
    try {


      const response = await apiClient.put(`/orientation/${id}/status`, { status });


      if (response.data && response.data.responseCode) {
        return response.data;
      } else {
        return {
          responseCode: 200,
          responseMessage: 'Orientation status updated successfully',
          data: response.data
        };
      }
    } catch (error) {

      throw error;
    }
  },

  // Get invitation details by inviteId (public endpoint, no auth required)
  getInvitationDetails: async (inviteId) => {
    try {


      const response = await apiClient.get(`/orientation/invite/${inviteId}`);


      if (response.data && response.data.responseCode) {
        return response.data;
      } else {
        return {
          responseCode: 200,
          responseMessage: 'Invitation details retrieved successfully',
          data: response.data
        };
      }
    } catch (error) {

      throw error;
    }
  },

  // Accept invitation
  acceptInvitation: async (inviteId) => {
    try {


      const response = await apiClient.post(`/orientation/invite/${inviteId}/accept`);


      return response;
    } catch (error) {

      throw error;
    }
  },

  // Decline invitation
  declineInvitation: async (inviteId) => {
    try {


      const response = await apiClient.post(`/orientation/invite/${inviteId}/decline`);


      return response;
    } catch (error) {

      throw error;
    }
  },

  // Send orientation reminders
  sendOrientationReminders: async (id) => {
    try {


      const response = await apiClient.post(`/orientation/${id}/reminders`);


      if (response.data && response.data.responseCode) {
        return response.data;
      } else {
        return {
          responseCode: 200,
          responseMessage: 'Reminders sent successfully',
          data: response.data
        };
      }
    } catch (error) {

      throw error;
    }
  },

  // Bulk upload orientations from parsed CSV data
  bulkUploadOrientations: async (orientations, options = {}) => {
    try {
      const { skipDuplicates = true } = options;
      const response = await apiClient.post('/orientation/bulk-upload', {
        orientations,
        skipDuplicates
      });

      if (response && (response.responseCode === 201 || response.responseCode === 200)) {
        return {
          success: true,
          data: response.data,
          message: response.responseMessage || 'Bulk upload completed'
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to upload orientations',
          data: response.data
        };
      }
    } catch (error) {

      return {
        success: false,
        error: error.response?.data?.responseMessage || error.message || 'Failed to upload orientations'
      };
    }
  },

  // Validate bulk upload data
  validateBulkUpload: async (orientations) => {
    try {
      const response = await apiClient.post('/orientation/bulk-upload/validate', {
        orientations
      });

      if (response && response.responseCode === 200) {
        return {
          success: true,
          data: response.data
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to validate orientations'
        };
      }
    } catch (error) {

      return {
        success: false,
        error: error.response?.data?.responseMessage || error.message || 'Failed to validate orientations'
      };
    }
  },

  // Download bulk upload template
  downloadBulkUploadTemplate: async (filename = 'orientation_bulk_upload_template.csv') => {
    try {
      const token = localStorage.getItem('auth_token') || localStorage.getItem('token');
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/orientation/bulk-upload/template`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Failed to download template');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      return { success: true };
    } catch (error) {

      return {
        success: false,
        error: error.message || 'Failed to download template'
      };
    }
  },

  // Parse CSV content
  parseCSV: (csvContent) => {
    try {
      const lines = csvContent.split(/\r?\n/).filter(line => line.trim());
      if (lines.length < 2) {
        return {
          success: false,
          error: 'CSV must contain a header row and at least one data row'
        };
      }

      const headers = parseCSVLine(lines[0]);
      const orientations = [];
      for (let i = 1; i < lines.length; i++) {
        const values = parseCSVLine(lines[i]);
        if (values.length === 0 || values.every(v => !v.trim())) continue;

        const orientation = {};
        headers.forEach((header, index) => {
          orientation[header.trim()] = values[index]?.trim() || '';
        });
        orientations.push(orientation);
      }

      return { success: true, orientations };
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to parse CSV'
      };
    }
  }
};

/**
 * Helper function to parse a CSV line handling quoted values
 */
const parseCSVLine = (line) => {
  const values = [];
  let current = '';
  let inQuotes = false;

  for (let i = 0; i < line.length; i++) {
    const char = line[i];
    const nextChar = line[i + 1];

    if (char === '"') {
      if (inQuotes && nextChar === '"') {
        current += '"';
        i++;
      } else {
        inQuotes = !inQuotes;
      }
    } else if (char === ',' && !inQuotes) {
      values.push(current);
      current = '';
    } else {
      current += char;
    }
  }

  values.push(current);
  return values;
};

export default orientationService;

